import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RestoreComponent } from './restore.component';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';

const routes: Routes = [
  {
    path: '',
    component: RestoreComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatDialogModule,
  ],
  declarations: [RestoreComponent],
  exports: [RouterModule],
  providers: [],
})
export class RestoreInProgressModule {}
